// @flow

import React from 'react';
import Pill from 'shared/components/common/Pill';
import { i18n } from 'shared/utils';

type Props = {
  status: string,
  width?: number,
};

const STATUS_COLORS = {
  OPEN: 'orange',
  PARTIALLY_FULFILLED: 'blue',
  FULFILLED: 'green',
  CLOSED: 'grey',
};

const STATUS_LABELS = {
  OPEN: 'Open',
  PARTIALLY_FULFILLED: 'Partial',
  FULFILLED: 'Fulfilled',
  CLOSED: 'Closed',
};

const BackorderStatusPill = ({ status, width }: Props) => (
  <Pill color={STATUS_COLORS[status] || 'grey'} width={width}>
    {i18n.t(STATUS_LABELS[status] || status)}
  </Pill>
);

export default BackorderStatusPill;
